import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from 'src/app/_services/auth.service';

declare var window: any;
@Component({
  selector: 'app-side-bar-guardian-home',
  templateUrl: './side-bar-guardian-home.component.html',
  styleUrls: ['./side-bar-guardian-home.component.css']
})
export class SideBarGuardianHomeComponent implements OnInit {
@Input() guardian = undefined
@Output() regFinished = new EventEmitter<string>()
@Input() target_student_user_id = 0

  registerStudentModal:any
  is_admin=false
  constructor( private authService:AuthService) { }
  ngOnInit(): void {
    this.authService.gatePass.subscribe(
      gatePass=>{
        this.is_admin = gatePass.is_role_admin
      }
    )
  }


  addStudentRegistrationPopup(){

  this.registerStudentModal = new window.bootstrap.Modal(
    document.getElementById('regStudentModal')
  );
  this.registerStudentModal.show()
  }


  closeModal(closeModalName:string){
    switch(closeModalName){
      case "regStudentModal":
         this.registerStudentModal.hide()
      default:
        ;
    }

  }

  reloadMainHomePage(closeModalName:string){
    this.regFinished.emit(closeModalName)
    }
}
